export const getBusinessUsageBreakdownUrl = () => '/business/usage/breakdown';

export const getBusinessUsageAnalyticsUrl = () => '/business/usage/analytics';

export const getBusinessUsageOverviewUrl = () => '/business/usage/overview';
